module.exports = __webpack_public_path__ + "static/media/noun_Abacus_1838090.1779f3ae.svg";